export {
  getPlainTextLength,
  isRichTextEmpty,
  isRichTextTooLong,
  stripHtmlTags,
} from "src/app/core/utils/rich-text-content.util";
